// Utilitaires d'impression pour les mouvements de métaux précieux

/**
 * Formate une date pour l'affichage (DD/MM/YYYY)
 */
export const formatDateForPrint = (dateString) => {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

/**
 * Échappe les caractères HTML pour éviter les injections
 */
export const escapeHtml = (str) => {
  return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

/**
 * Formate un nombre avec 2 décimales pour l'impression simple
 */
export const formatNumber = (n) => {
  return (n === 0 || n) ? Number(n).toFixed(2) : '';
};

/**
 * Formate un nombre avec 3 décimales pour l'impression officielle
 */
export const formatNumberPrecise = (n) => {
  return (n === 0 || n) ? Number(n).toFixed(3) : '';
};

/**
 * Crée et affiche un iframe pour l'impression
 */
export const createPrintIframe = (html) => {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.visibility = 'hidden';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();

  return iframe;
};

/**
 * Informations par défaut de l'entreprise
 */
export const getCompanyInfo = () => ({
  name: 'ATC Joaillerie',
  address: '27 Rue Vacon',
  city: '13001 Marseille',
  siret: 'SIRET : 482 160 256 00020'
});

/**
 * Détermine le type de métal
 */
export const getMetalType = (metalId) => {
  const id = String(metalId);
  return {
    isGold: id === '1',
    isArgent: id === '2',
    isPlatine: id === '3'
  };
};

/**
 * Obtient le label d'un métal
 */
export const getMetalLabel = (metalObj, metalId) => {
  const { isGold, isArgent, isPlatine } = getMetalType(metalId);
  return metalObj.description || 
         (isGold ? 'Or' : isArgent ? 'Argent' : isPlatine ? 'Platine' : `Métal ${metalId}`);
};